import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable, tap } from 'rxjs';

export interface DialPhoneData {
    name: string;
    dial_code: string;
    code: string;
}
@Injectable({
    providedIn: 'root'
})
export class DialPhoneService {

    #dialPhoneData$ = new BehaviorSubject<DialPhoneData[]>([]);
    dialPhoneDataObs$ = this.#dialPhoneData$.asObservable();

    get dialPhoneValue() {
        return this.#dialPhoneData$.value;
    }

    constructor(private http: HttpClient) { }

    loadDialPhoneData(): Observable<any> {
        return this.http.get('assets/data/dialphone.json').pipe(
            tap((data: DialPhoneData[]) => {
                this.#dialPhoneData$.next(data);
            })
        )
    }

    findDialCode(dialCode: string): DialPhoneData {
        return this.#dialPhoneData$.value.find((item) => item.dial_code === dialCode);
    }
}